<pp-avatar class="avatar" [avatar]="avatar()" [firstName]="caption()[0]" />

@if (!onlyAvatar()) {
  <div class="info">
    <h4 class="name">
      {{ caption() }}
    </h4>
    <span class="role">
      {{ label() }}
    </span>
  </div>
}
